module.exports = __webpack_public_path__ + "static/img/loading.99b0c13a.png";